<template>
  <v-data-table
    :headers="relationFields"
    :items="current_qunit[props.attr]"
    item-key="uid"
    class="qmkey-explorer-table-expansion-table table-contrast-expand-icon"
    dense
    sort-by="modification_date"
    must-sort
    sort-desc
    show-expand
  >
    <template v-slot:expanded-item="{ item }">
      <td
        :colspan="unitColumns.length + 1"
        class="qmkey-explorer-table-expansion-td"
      >
        <v-container fluid>
          <v-row class="qmkey-explorer-table-expansion-cont">
            <v-col>
              {{ item.message }}
            </v-col>
          </v-row>
        </v-container>
      </td>
    </template>
  </v-data-table>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'InlineBoxComunications',
  props: {
    current_qunit: Object,
    props: Object
  },
  data() {
    return {
      relationFields: [
        { value: 'title', text: 'Title', sortable: true },
        { value: 'current_workflow_responsible', text: 'Responsible' },
        { value: 'current_workflow_limit', text: 'Limit' },
        { value: 'current_workflow_state', text: 'State' },
        { value: 'readable_type', text: 'Type', sortable: true },
        { value:'data-table-expand', text: '', sortable: false}
      ],
    }
  },
  computed: {
    ...mapState([
      'unitColumns',      
    ]),
  }

}
</script>

<style lang="scss">
    @import "@/sass/explorer.scss";
</style>
